import React from "react";

import colors from "core/colors";

import { Disclaimer } from "subscriptions/styles";

import {
    DisclaimerTextMonthly,
    DisclaimerTextYearly,
    PRO_MONTHLY_PLAN,
    TEAM_MONTHLY_PLAN
} from "subscriptions/data";

const DisclaimerBodyText = ({ licenseSelection }) => {
    const monthlyPlans = [PRO_MONTHLY_PLAN, TEAM_MONTHLY_PLAN];
    const isMonthly = monthlyPlans.includes(licenseSelection);

    return (
        <Disclaimer size="md" type="p" copyColor={colors.secondary.oolong}>
            {isMonthly ? DisclaimerTextMonthly : DisclaimerTextYearly}
        </Disclaimer>
    );
};

export default DisclaimerBodyText;
